import styled from 'styled-components';

export const Container = styled.div`
	padding: 16px;

	& > .ant-card {
		margin: 12px 0;
	}
`;

export const SearchContainer = styled.header`
	width: 100%;
	display: flex;
	align-items: center;
	padding-bottom: 16px;
	justify-content: center;
`;

export const CasterCell = styled.div`
	display: flex;
	align-items: center;

	& > div.caster-name {
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;

		& > .email {
			font-size: 13px;
			color: rgba(0, 0, 0, 0.45) !important;
			margin-top: -4px;
		}
	}
`;

export const DetailsContainer = styled.div`
	width: 100%;

	& > ul {
		margin-top: 32px;
		width: 100%;

		& > li {
			padding: 16px 12px;
			border-bottom: 1px dashed #dedede;
			display: flex;
			align-items: center;
			justify-content: space-between;

			& > strong {
				font-size: 16px;
			}

			& > span.label {
				font-size: 15px;
				font-weight: 300;
			}
		}
	}
`;
